import { apiClient } from '~/services/api-service';
import { Id } from '~/types/common';

export const socialMediaMicrositeAPIService = {
  getSocialMediaSite: (id: Id) => {
    return apiClient.get(`/microsite/social-media/${id}/`);
  },
  createSocialMediaSite: (body) => {
    return apiClient.post(`/microsite/social-media/`, body);
  },
  updateSocialMediaSite: (body, id: Id) => {
    return apiClient.patch(`/microsite/social-media/${id}/`, body);
  },
  deleteSocialMediaSite: (body, id: Id) => {
    return apiClient.delete(`/microsite/social-media/${id}/`, body);
  },

  //networks-links
  getSocialNetworksSite: (id: Id) => {
    return apiClient.get(`/microsite/social-media-microsite/networks-links/${id}/`);
  },
  createSocialNetworksSite: (body) => {
    return apiClient.post(`/microsite/social-media-microsite/networks-links/`, body);
  },
  updateSocialNetworksSite: (body, id: Id) => {
    return apiClient.patch(`/microsite/social-media-microsite/networks-links/${id}/`, body);
  },
  deleteSocialNetworksSite: (id: Id) => {
    return apiClient.delete(`/microsite/social-media-microsite/networks-links/${id}/`);
  },
};
